import React, { type ComponentType } from 'react';

import type { ChildIssue } from '@atlassian/jira-issue-shared-types/src/common/types/children-issues-type.tsx';
import type { ChildIssuesLimitStatus } from '@atlassian/jira-issue-view-common-constants/src/child-issues.tsx';
import { SectionHeadingIcons } from '@atlassian/jira-issue-view-common/src/component/section-heading/section-heading-view.tsx';
import type { RefObject } from '@atlassian/jira-shared-types/src/general.tsx';
import type { AddChildEventHandler } from '../add-child/types.tsx';
import { SectionHeadingIcons as SectionHeadingActions } from './SectionHeadingIcons.tsx';

type ConnectProps = {
	Meatballs: ComponentType<{
		childIssuesLimitStatus: ChildIssuesLimitStatus;
		isSortingAvailable?: boolean;
		isHideDoneFilterEnabled: boolean | null | undefined;
		userPreferencesConnectionId: string | undefined;
		// TODO: Make required on hide-rank-option-when-unavailable cleanup
		isRankingEnabled?: boolean;
	}>;
	AddChild: ComponentType<{
		onClick?: AddChildEventHandler;
	}>;
	allIssues: ChildIssue[];
	supportsIssueCreation: boolean | undefined;
	isSortingAvailable: boolean;
};

type ParentProps = {
	childIssuesLimitStatus: ChildIssuesLimitStatus;
	issueHierarchyLevel?: number | undefined;
	onAddChildClick: AddChildEventHandler | undefined;
	isHideDoneFilterEnabled: boolean | null | undefined;
	userPreferencesConnectionId: string | undefined;
	// TODO: Make required on hide-rank-option-when-unavailable cleanup
	isRankingEnabled?: boolean;
	columnPickerRef?: RefObject<HTMLDivElement>;
};

export type Props = ConnectProps & ParentProps;

function HeaderSectionHeadingIcons(props: Props) {
	return (
		<SectionHeadingIcons>
			<SectionHeadingActions {...props} />
		</SectionHeadingIcons>
	);
}

export default HeaderSectionHeadingIcons;
